import type { IntlShape } from 'react-intl';

import { getBrowserInfo } from '@atlaskit/editor-common/browser';
import { type ViewMode } from '@atlaskit/editor-plugin-editor-viewmode';
import type { PlaceholderPluginOptions } from '@atlaskit/editor-plugin-placeholder';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/editor-experiment';

import { i18n } from './i18n';

interface Props {
	intl: IntlShape;
	options: {
		isAIEnabled: boolean;
		viewMode: ViewMode | undefined;
	};
}

export function placeholderPluginOptions({ intl, options }: Props): PlaceholderPluginOptions {
	const placeholder = (() => {
		if (options.viewMode === 'view') {
			return undefined;
		}

		if (!options.isAIEnabled) {
			const browser = getBrowserInfo();
			const key = browser.mac ? '⌘' : 'Ctrl';
			return intl.formatMessage(i18n.editorEmptyDocumentPlaceholderAI, { key });
		}

		if (editorExperiment('platform_editor_controls', 'variant1')) {
			return intl.formatMessage(i18n.defaultPlaceholder);
		}

		return intl.formatMessage(i18n.easyCommandsPlaceholder);
	})();

	return {
		placeholder,
	};
}
